__turbopack_context__.v({
  "img": "styles-module-scss-module__1-k7rG__img",
  "logoGridContainer": "styles-module-scss-module__1-k7rG__logoGridContainer",
  "logoWrapper": "styles-module-scss-module__1-k7rG__logoWrapper",
});
